import React, { useState, useEffect } from 'react';
import { storage, firestore } from '../config/firebaseConfig';
import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { doc, updateDoc, getDoc } from 'firebase/firestore';
import './UploadLogo.css'

function UploadLogo() {
  const [file, setFile] = useState(null);
  const [error, setError] = useState('');
  const [tenantId, setTenantId] = useState(null);

  // Ao montar o componente, verifica o localStorage para encontrar o tenantId
  useEffect(() => {
    const storedTenantId = localStorage.getItem('tenantId');
    if (storedTenantId) {
      setTenantId(storedTenantId);
      
    } else {
      setError('Acesso negado: Faça login para continuar.');
    }
  }, []);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.type.includes('image')) {
      setFile(selectedFile);
      setError('');
      console.log('Arquivo selecionado:', selectedFile.name);
    } else {
      setError('Por favor, selecione um arquivo de imagem válido');
    }
  };

  const handleUpload = async () => {
    if (!file || !tenantId) {
      setError('Acesso negado ou arquivo inválido');
      return;
    }

    const fileName = `logo.png`; // Define um nome fixo para o arquivo
    const storageRef = ref(storage, `logos/${tenantId}/${fileName}`);

    try {
      // Tenta excluir o arquivo existente
      await deleteObject(storageRef);
      console.log('Logotipo anterior excluído com sucesso');
    } catch (error) {
      if (error.code !== 'storage/object-not-found') {
        console.error('Erro ao excluir o logotipo anterior:', error);
        setError('Erro ao excluir logotipo anterior.');
        return;
      }
    }

    try {
      console.log('Iniciando upload para o Storage');
      const snapshot = await uploadBytes(storageRef, file);
      console.log('Upload concluído, obtendo URL de download');

      const url = await getDownloadURL(snapshot.ref);
      console.log('URL do logotipo obtido:', url);

      // Referência ao documento correto na coleção `inquilinos`
      const tenantDocRef = doc(firestore, 'inquilinos', tenantId);
      const tenantDocSnap = await getDoc(tenantDocRef);

      if (tenantDocSnap.exists()) {
        // Atualiza o documento com o novo logoUrl
        console.log('Documento encontrado, atualizando o logoUrl');
        await updateDoc(tenantDocRef, { logoUrl: url });
        alert('Logotipo enviado com sucesso!');
      } else {
        console.log('Documento com tenantId não encontrado na coleção inquilinos');
        setError('Erro: Documento não encontrado para este tenantId.');
      }
    } catch (err) {
      console.error('Erro ao enviar logotipo:', err);
      setError('Erro ao enviar logotipo. Tente novamente mais tarde.');
    }
  };

  return (
    <div>
      <input type="file" onChange={handleFileChange} />
      {error && <p>{error}</p>}
      <button onClick={handleUpload} disabled={!file || !tenantId}>Upload</button>
    </div>
  );
}

export default UploadLogo;
